<template>
  <div class="row bgc-wrapper margin-top-42">
    <div class="col-12 traveller-heading">
      <div class="row">
        <button
          type="button"
          class="expand-form-button pt-1"
          data-toggle="collapse"
          aria-label="Expand Journey Details"
          data-target="#customerDetails"
        >
          <img alt="Toggle Customer Details" src="@/assets/images/arr-up.png" />
        </button>
        <div class="col-6 p-0">
          <h3>Customer Details</h3>
        </div>
      </div>
    </div>
    <div class="collapse show col-12 bgc-form-box" id="customerDetails">
      <!--Partner Type starts-->
      <div class="row">
        <div class="flex-item form-group col-lg-12 col-md-12 col-sm-12 p-0">
          <div class="col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label label="Partner Type*" :fixed="isFloat(customerData.partnerType.value)">
              <select
                class="form-control customer-partner"
                :class="{ 'bgc-error-field': customerData.partnerType.errorText!=='' }"
                v-model="customerData.partnerType.value"
                v-evolvews="customerData.partnerType"
                :disabled="isModify"
                @change="mandateName()"
              >
                <option value selected disabled hidden>Partner Type*</option>
                <option
                  v-for="type in partnerType"
                  :key="type.code"
                  :value="type.code"
                >{{type.name}}</option>
              </select>
            </float-label>
            <span
              class="error-text"
              v-if="customerData.partnerType.errorText!==''"
            >{{customerData.partnerType.errorText}}</span>
          </div>
          <!-- Organisation Name starts -->
          <div
            class="middle-margin col-lg-3 col-md-3 col-sm-6 p-0"
            v-if="customerData.partnerType.value === 'ORG'"
          >
            <float-label
              label="Organization Name"
              :fixed="isFloat(customerData.organizationName.value)"
            >
              <input
                type="text"
                placeholder="Organization Name"
                class="form-control"
                @blur="onBlurOrgName($event)"
                :disabled="isModify"
                v-model="customerData.organizationName.value"
              />
            </float-label>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <!--First Name starts-->
        <div
          class="flex-item form-group col-lg-12 col-md-12 col-sm-12 p-0"
          v-if="customerData.partnerType.value === 'IND'"
        >
          <div
            class="col-lg-3 col-md-3 col-sm-6 p-0"
            v-if="customerData.partnerType.value === 'IND'"
          >
            <float-label label="First Name*" :fixed="isFloat(customerData.firstName.value)">
              <input
                type="text"
                placeholder="First Name*"
                class="form-control"
                :class="{ 'bgc-error-field': customerData.firstName.errorText!=='' }"
                v-evolvews="customerData.firstName"
                :disabled="isModify"
                v-model="customerData.firstName.value"
              />
            </float-label>
            <span
              class="error-text"
              v-if="customerData.firstName.errorText!==''"
            >{{customerData.firstName.errorText}}</span>
          </div>
          <!--First Name ends-->
          <!--Middle Name starts-->
          <div
            class="middle-margin col-lg-3 col-md-3 col-sm-6 p-0"
            v-if="customerData.partnerType.value === 'IND'"
          >
            <float-label label="Middle Name" :fixed="isFloat(customerData.middleName.value)">
              <input
                type="text"
                class="form-control"
                placeholder="Middle Name"
                :disabled="isModify"
                v-model="customerData.middleName.value"
              />
            </float-label>
          </div>
          <!--Middle Name end-->
          <!--Last Name starts-->
          <div
            class="margin-specify col-lg-3 col-md-3 col-sm-6 p-0"
            v-if="customerData.partnerType.value === 'IND'"
          >
            <float-label label="Last Name*" :fixed="isFloat(customerData.lastName.value)">
              <input
                type="text"
                placeholder="Last Name*"
                class="form-control"
                :class="{ 'bgc-error-field': customerData.lastName.errorText!=='' }"
                :disabled="isModify"
                v-evolvews="customerData.lastName"
                v-model="customerData.lastName.value"
              />
            </float-label>
            <span
              class="error-text"
              v-if="customerData.lastName.errorText!==''"
            >{{customerData.lastName.errorText}}</span>
          </div>
        </div>
        <!--Last Name end-->
        <!--Address Line 1 starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
          <float-label label="Address Line 1*" :fixed="isFloat(customerData.addressLine1.value)">
            <input
              type="text"
              placeholder="Address Line 1*"
              class="form-control customer-address"
              :class="{ 'bgc-error-field': customerData.addressLine1.errorText!=='' }"
              v-evolvews="customerData.addressLine1"
              v-model="customerData.addressLine1.value"
            />
          </float-label>
          <span
            class="error-text"
            v-if="customerData.addressLine1.errorText!==''"
          >{{customerData.addressLine1.errorText}}</span>
        </div>
        <!--Address Line 1 end-->
        <!--Address Line 2 starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
          <float-label label="Address Line 2" :fixed="isFloat(customerData.addressLine2.value)">
            <input
              type="text"
              placeholder="Address Line 2"
              class="form-control"
              v-model="customerData.addressLine2.value"
            />
          </float-label>
        </div>
        <!--Address Line 2 end-->
        <!--Landmark starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
          <float-label label="Landmark*" :fixed="isFloat(customerData.landmark.value)">
            <input
              type="text"
              placeholder="Landmark*"
              class="form-control customer-landmark"
              :class="{ 'bgc-error-field': customerData.landmark.errorText!=='' }"
              v-model="customerData.landmark.value"
              v-evolvews="customerData.landmark"
            />
          </float-label>
          <span
            class="error-text"
            v-if="customerData.landmark.errorText!==''"
          >{{customerData.landmark.errorText}}</span>
        </div>
        <!--Landmark end-->
        <!--Pincode starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
          <float-label label="Pincode*" :fixed="isFloat(customerData.pincode.value)">
            <input
              type="text"
              placeholder="Pincode*"
              v-on:keydown="onlyNumber"
              class="form-control customer-pincode"
              maxlength="6"
              :class="{ 'bgc-error-field': customerData.pincode.errorText!=='' }"
              v-model="customerData.pincode.value"
              @input="callAreaByPinCode()"
              v-evolvews="customerData.pincode"
            />
          </float-label>
          <span
            class="error-text"
            v-if="customerData.pincode.errorText!==''"
          >{{customerData.pincode.errorText}}</span>
        </div>
        <!--Pincode end-->
        <!--State starts-->
        <div class="flex-item form-group col-lg-12 col-md-12 col-sm-12 p-0">
          <div class="col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label label="State" :fixed="isFloat(customerData.state.value)">
              <input
                type="text"
                placeholder="State"
                class="form-control"
                :disabled="true"
                v-model="customerData.state.value"
              />
            </float-label>
          </div>
          <!--State end-->
          <!--City starts-->
          <div class="middle-margin col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label label="City" :fixed="isFloat(customerData.city.value)">
              <input
                type="text"
                placeholder="City"
                class="form-control"
                :disabled="true"
                v-model="customerData.city.value"
              />
            </float-label>
          </div>
          <!--City end-->
          <!--Area starts-->
          <div class="margin-specify col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label label="Area" :fixed="isFloat(customerData.area.value)">
              <select class="form-control" 
                v-model="customerData.area.value" placeholder="Area" 
                :class="{ 'bgc-error-field': customerData.area.errorText!=='' }"
                v-evolvews="customerData.area"
                >
                <option value selected disabled hidden>Area</option>
                <option v-for="area in state.db.areas" :key="area.areaCode">{{area.areaName}}</option>
              </select>
            </float-label>
            <span
              class="error-text"
              v-if=" customerData.area.errorText!==''"
            >{{ customerData.area.errorText}}</span>
          </div>
        </div>
        <!--Area end-->
        <!--Mobile Number starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
          <float-label label="Mobile Number*" :fixed="isFloat(customerData.mobileNumber.value)">
            <input
              type="text"
              placeholder="Mobile Number*"
              v-on:keydown="onlyNumber"
              class="form-control customer-mobile"
              :class="{ 'bgc-error-field': customerData.mobileNumber.errorText!=='' }"
              v-model="customerData.mobileNumber.value"
              v-evolvews="customerData.mobileNumber"
              maxlength="10"
            />
          </float-label>
          <span
            class="error-text"
            v-if="customerData.mobileNumber.errorText!==''"
          >{{customerData.mobileNumber.errorText}}</span>
        </div>
        <!--Mobile Number ends-->
        <!--Telephone Number starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
          <float-label
            label="Telephone Number"
            :fixed="isFloat(customerData.telephoneNumber.value)"
          >
            <input
              type="text"
              placeholder="Telephone Number"
              :disabled="isModify"
              v-on:keydown="onlyNumber"
              class="form-control"
              v-model="customerData.telephoneNumber.value"
              maxlength="8"
            />
          </float-label>
        </div>
        <!--Telephone Number ends-->
        <!--Alternate Number starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
          <float-label
            label="Alternate Number"
            :fixed="isFloat(customerData.alternateNumber.value)"
          >
            <input
              type="text"
              placeholder="Alternate Number"
              v-on:keydown="onlyNumber"
              :disabled="isModify"
              class="form-control customer-alternate-number"
              :class="{ 'bgc-error-field': customerData.alternateNumber.errorText!=='' }"
              v-evolvews="customerData.alternateNumber"
              v-model="customerData.alternateNumber.value"
              maxlength="10"
            />
          </float-label>
          <span
            class="error-text"
            v-if="customerData.alternateNumber.errorText!==''"
          >{{customerData.alternateNumber.errorText}}</span>
        </div>
        <!--Alternate Number ends-->
        <!--Customer Email ID starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
          <float-label
            label="Customer Email ID"
            :fixed="isFloat(customerData.customerEmailId.value)"
          >
            <input
              type="text"
              placeholder="Customer Email ID"
              :disabled="isModify"
              class="form-control customer-email"
              v-evolvews="customerData.customerEmailId"
              :class="{ 'bgc-error-field': customerData.customerEmailId.errorText!=='' }"
              v-model="customerData.customerEmailId.value"
            />
          </float-label>
          <span
            class="error-text"
            v-if="customerData.customerEmailId.errorText!==''"
          >{{customerData.customerEmailId.errorText}}</span>
        </div>
        <!--Customer Email ID ends-->
      </div>
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../../shared_component/FloatLabel.vue";
import functions from "@/../../masters/functions.js";
import RadialProgressBar from "vue-radial-progress";
import { reactive, computed, watchEffect } from '@vue/composition-api';

export default {
  name: "CustomerDetails",
  props: [
    "customerData",
    "isModify",
    "partnerType",
    "organizationName",
    "fetchedareas",
  ],
  components: {
    FloatLabel,
    RadialProgressBar
  },
  setup(props, context){
    let state = reactive({
        db: {
        areas: [],
      },
      customerProgressBar: {
        startColor: "#007bff",
        stopColor: "#007bff",
        innerStrokeColor: "#D3D3D3",
      },
    });
    //computed
    const totalSteps = computed(()=>{
      if (props.customerData.partnerType.value == "IND") return 7;
      return 5;
    });
    const completedSteps = computed(()=>{
      let count;
      if (props.customerData.partnerType.value == "IND") {
        let count = 0;
        if (props.customerData.firstName.value != "" && props.customerData.firstName.errorText == "")
          count++;
        if (props.customerData.lastName.value != "" && props.customerData.lastName.errorText == "")
          count++;
        if (props.customerData.addressLine1.value != "" && props.customerData.addressLine1.errorText == "")
          count++;
        if (props.customerData.landmark.value != "" && props.customerData.landmark.errorText == "")
          count++;
        if (props.customerData.pincode.value != "" && props.customerData.pincode.errorText == "")
          count++;
        if (props.customerData.mobileNumber.value != "" && props.customerData.mobileNumber.errorText == "")
          count++;
        return count + 1;
      } 
      else {
        let count = 0;
        if (props.customerData.partnerType.value != "" && props.customerData.partnerType.errorText == "")
          count++;
        if (props.customerData.addressLine1.value != "" && props.customerData.addressLine1.errorText == "")
          count++;
        if (props.customerData.landmark.value != "" && props.customerData.landmark.errorText == "")
          count++;
        if (props.customerData.pincode.value != "" && props.customerData.pincode.errorText == "")
          count++;
        if (props.customerData.mobileNumber.value != "" && props.customerData.mobileNumber.errorText == "")
          count++;
        return count;
      }
    });
    //functions
    const mandateName = () => {
      if(props.customerData.partnerType.value === 'IND') {
        context.root.$set(props.customerData.firstName,'required',true);
        context.root.$set(props.customerData.lastName,'required',true);
        delete props.customerData.firstName.skip;
        delete props.customerData.lastName.skip;
      }
      if(props.customerData.partnerType.value === 'ORG'){
        context.root.$set(props.customerData.firstName,'required',false);
        context.root.$set(props.customerData.lastName,'required',false);
        context.root.$set(props.customerData.firstName,'skip', true);
        context.root.$set(props.customerData.lastName,'skip', true);
      }
    }
    const isFloat= functions.isFloat;
    const referenceID= functions.referenceID;
    const checkError= functions.checkError;
    const removeErrorIfNotBlank= functions.removeErrorIfNotBlank;
    const onlyNumber= functions.onlyNumber;
    function callAreaByPinCode() {
      context.parent.getAreaByPincode();
    }
    function onBlurOrgName(e){
      if(e.target.value){
        props.customerData.organizationName.value = e.target.value.toUpperCase();
      }
    }
    //watch
    watchEffect(()=>{
      if (props.fetchedareas != undefined && props.fetchedareas != null && props.fetchedareas.length > 0){
          state.db.areas = props.fetchedareas;
      }
    });
    return{
      state,
      totalSteps,
      completedSteps,
      isFloat,
      referenceID,
      checkError,
      removeErrorIfNotBlank,
      onlyNumber,
      onBlurOrgName,
      callAreaByPinCode,
      mandateName
    }
  },
  directives: {
    evolvews: functions.evolvews,
  }
};
</script>
<style scoped>
.flex-item {
  display: flex;
}
.mandatory-text {
  font-style: italic;
  font-size: 14px;
}
.progress-mandatory {
  font-size: 11px;
}
.progress-completed {
  font-size: 11px;
}
.radial-margin {
  margin: auto;
}
.mobile-label {
  display: none;
}
.organization-position {
  position: absolute;
  left: 74%;
  top: -25px;
}
.individual-position {
  position: absolute;
  left: 83%;
  top: -25px;
}
@media only screen and (max-width: 767px) {
  .remove-space {
    display: none;
  }
  .flex-item {
    flex-wrap: wrap;
  }
  .margin-specify {
    margin-top: 24px;
    margin-bottom: 5px;
  }
}
@media (max-width: 920px) {
  .mandatory-text {
    font-size: 12px;
  }
  .progress-mandatory {
    font-size: 9px;
  }
  .progress-completed {
    font-size: 9px;
  }
}
@media (max-width: 767px) {
  .mobile-label {
    font-size: 12px;
    display: block;
  }
  .mandatory-text {
    display: none;
  }
  .progress-proposer {
    position: relative;
    bottom: 80px;
  }
  .registration-number {
    position: relative;
    top: 145px;
  }
  .organization-position,
  .individual-position {
    position: relative ;
    left: -4px ;
    top: 10px ;
  }
  .progress-mandatory {
    font-size: 9px;
  }
  .progress-completed {
    font-size: 9px;
  }
}
@media (max-width: 575px){
  .organization-position{
    top: -35px;
  }
  .middle-margin{
    margin-top: 24px;
  }
}
@media (max-width: 1100px) and (min-width: 768px) {
  .organization-position {
    position: absolute;
    left: 72%;
    top: -25px;
  }
  .individual-position {
    position: absolute;
    left: 80%;
    top: -25px;
  }
}
</style>